define('TescoMobile_ClubCard/js/view/cca-price',['jquery', 'mage/translate', 'Magento_Catalog/js/price-utils'], function ($, $t, priceUtils) {
  'use strict';

  const mixin = {
    ccaConfigClubCard: {},
    clubCardPrice: null,
    defaults: {
      imports: {
        ccaConfigClubCard: "tm-clubcard-price-provider:ccaConfigClubCard",
        clubCardPrice: "tm-clubcard-price-provider:clubCardPrice"
      }
    },
    initialize: function () {
      this._super();
      this.clubCardPrice.subscribe(this.updateFullPriceLabel, this);
      this.selectedPuf.subscribe(this.updateFullPriceLabel, this);
      this.deviceFullPrice.subscribe(this.updateFullPriceLabel, this);
    },
    initObservable: function () {
      this._super().observe(['clubCardPrice']);
      return this;
    },
    updateFullPriceLabel: function () {
      const pufOptionElement = $(this.pufOptionSelector).parent('.all').find('label'),
        pufPriceLabel = $('.selected-price.puf-price');
      if (!this.clubCardPrice() || !this.ccaConfigClubCard.hasOwnProperty(this.selectedOptionId()) || !this.ccaConfigClubCard[this.selectedOptionId()].hasOwnProperty(this.selectedOptionValue())) {
        var _pufOptionElement$fin, _pufOptionElement$clo;
        pufOptionElement.removeClass('ccp');
        pufPriceLabel.removeClass('ccp');
        (_pufOptionElement$fin = pufOptionElement.find('.clubcard-price-wrapper')) === null || _pufOptionElement$fin === void 0 ? void 0 : _pufOptionElement$fin.remove();
        (_pufOptionElement$clo = pufOptionElement.closest('.fieldset-tm-bundle-options').find('.puf-price.selected-price')) === null || _pufOptionElement$clo === void 0 || (_pufOptionElement$clo = _pufOptionElement$clo.find('.clubcard-price-wrapper')) === null || _pufOptionElement$clo === void 0 ? void 0 : _pufOptionElement$clo.remove();
        return;
      }
      const clubCardFullPrice = this.ccaConfigClubCard[this.selectedOptionId()][this.selectedOptionValue()]['full_device_price'];
      if (!clubCardFullPrice) {
        return;
      }
      if (pufOptionElement.find('.clubcard-price-wrapper').length > 0) {
        return;
      }
      if (this.clubCardPrice()) {
        pufOptionElement.addClass('ccp');
        pufPriceLabel.addClass('ccp');
      }
      pufOptionElement.html(`${pufOptionElement.html()}
<span class="clubcard-price-wrapper">
    <span class="clubcard-price-label">${$t('Clubcard Price')}</span>
    <span class="clubcard-price-value">
        ${$t('<span>%1</span>').replace('%1', priceUtils.formatPrice(clubCardFullPrice))}
    </span>
</span>`);
      if (this.selectedPuf() === 'all') {
        pufOptionElement.closest('.fieldset-tm-bundle-options').find('.puf-price.selected-price').html(pufOptionElement.html());
      }
    }
  };
  return function (target) {
    return target.extend(mixin);
  };
});

